module.exports = __webpack_public_path__ + "img/logo.2c13a155.png";